<div class="redefinicao__senha">
  <div class="redefinicao__senha__container">
    <p (click)="voltarParaHome()" class="redefinicao__voltar">
      <img class="icone__voltar" src="assets/images/icons/voltar.png" />Lembrei
    </p>
    <div class="card__container">
      <p class="container__titulo">Esqueceu sua senha?</p>
      <div class="container__descricao">
        <p class="descricao__texto">Deixe comigo, crush.</p>
        <p class="descricao__texto">
          Digite seu CPF e enviaremos as instruções necessárias para o e-mail
          cadastrado.
        </p>
      </div>
      <form (ngSubmit)="enviarEmail()">
        <div class="lovers-input__container">
          <label for="cpf" class="lovers-label">CPF</label>
          <input type="text" class="lovers-input input__cpf" pattern="[0-9]*" inputmode="numeric"
            placeholder=" 000.000.000-00" mask="000.000.000-00" name="cpf" [(ngModel)]="cpf" />

          <div *ngIf="exibeErro">
            <label class="text-danger"> Campo obrigatório! </label>
          </div>

          <div>
            <input type="submit" value="Enviar" class="lovers-button" />
          </div>
        </div>
      </form>
    </div>
    <p class="descricao__detalhes">
      Caso o e-mail cadastrado não esteja mais em uso ou você nunca tenha
      realizado o cadastro no programa de fidelidade Cacau Lovers, entre em
      contato pelo site
      <a href="https://lovers.cacaushow.com.br/ajuda " class="email__link"
        target="_blank"><strong>lovers.cacaushow.com.br/ajuda</strong></a>
      ou pelo telefone 4004-2987 (Capitais e região metropolitana) ou 0800
      119263 (demais regiões), para solicitar a alteração.
    </p>
    <img src="assets/images/backgrounds/radial_red.png" class="background__image" />
  </div>
</div>